import { render, staticRenderFns } from "./PanelTasks.vue?vue&type=template&id=26a39978&scoped=true&"
import script from "./PanelTasks.vue?vue&type=script&lang=js&"
export * from "./PanelTasks.vue?vue&type=script&lang=js&"
import style0 from "./PanelTasks.vue?vue&type=style&index=0&id=26a39978&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a39978",
  null
  
)

export default component.exports